import { Popover } from "@cloudscape-design/components";
import React from "react";
import { getUserType } from "../../pages/commons/functions";
import { useGlobalState } from "../../pages/context/GlobalStateContext";
import BadgeCustom from "./BadgeCustom";

type BadgeProps = {
  idUserType: number;
  size?: "small" | "medium" | "large";
  type?: "min" | "normal"
};

const Badge: React.FC<BadgeProps> = ({ idUserType = 0, size = "small", type = "normal" }) => {
  const { data } = useGlobalState();
  const color = getUserType(idUserType, data).color || "gray";
  const userType = getUserType(idUserType, data) || "gray";
  return (
    <>
      <BadgeCustom color={color} size={size}>
        {/* If type is "min", wrap the abbreviation (userType.ut) in a Popover 
                    that shows the full name (userType.displayName) on hover.
                */}
        {type === "min" ? (
          <Popover content={userType.userType}
            dismissButton={false} triggerType="custom">
            {userType.ut}
          </Popover>
        ) : (
          /* Otherwise, show the full display name */
          userType.userType
        )}
      </BadgeCustom>
    </>
  );
};

export default Badge;
